import React from "react";
import BubbleTalk from "components/BubbleTalk";
import { ButtonContinue } from "components/Button";
import { useThemeContext } from "context/ThemeContext";
import { useAppContext } from "context/AppContext/AppContext";
import { goToNextStep } from "context/AppContext/actions";
import StyledScenarioIntro from "components/styled/ScenarioIntro.styled";
import { motion } from "framer-motion";



const ScenarioIntro = ({ intro }) => {
  const { theme } = useThemeContext();
  const {state, dispatch} = useAppContext()

  return (
    <StyledScenarioIntro className="scenario-intro" backgroundColor={intro?.backgroundColor || ""} backgroundImageWidth={intro?.backgroundImageWidth}>
      {intro?.backgroundImage && (
        <div className="background-image">
          <intro.backgroundImage />
        </div>
      )}
      <div className="content" >
       <motion.div className="content-wrapper" initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2, duration: 0.3 }}>
        <BubbleTalk backgroundColor={intro?.bubbleTalkBackgroundColor || theme.colors.primary} textColor={intro?.bubbleTalkTextColor || "#fff"} >
            {intro?.text && <div className="intro-text margin-b-2" dangerouslySetInnerHTML={{ __html: intro.text }}></div>}
            {state.scenario.firstStepId && <ButtonContinue noHover={true} onClick={() => dispatch(goToNextStep(state.scenario.firstStepId))}/>}
          </BubbleTalk>
       </motion.div>
      </div>
    </StyledScenarioIntro>
  );
};

export default ScenarioIntro;
